import React from 'react';
import styled from 'styled-components';

const colors = {
  Aplus: '#1a4421',
  A: '#1a4421',
  B: '#0a6535',
  C: '#69b144',
  D: '#eae720',
  E: '#f48722',
  F: '#e71d25',
  G: '#e71d25',
  onbekend: 'gray',
};

const EnergyLabel = ({ label, className }) => label && (
  <Label score={label} className={className}>
    <Number>{label === 'onbekend' ? '?' : label}</Number>
  </Label>
);

const Label = styled.span`
  display: inline-block;
  vertical-align: middle;
  background-color: ${(props) => colors[props.score]};
  color: white;
  position: relative;
  height: 1.6rem;
  width: 2rem;
  font-weight: bold;

  &:after {
    position: absolute;
    top: 0;
    left: 100%;
    content: "";
    width: 0;
    height: 0;
    border-top: 0.8rem solid transparent;
    border-bottom: 0.8rem solid transparent;
    border-left: 0.8rem solid ${(props) => colors[props.score]};
  }
`;

const Number = styled.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: .5rem;
`;

export default styled(EnergyLabel)``;
